import React from 'react';
import Radio from '@material-ui/core/Radio';

export default function RadioButtonGroup(props) {
    const {similarColorThumb, setSimilarColorThumb} = props;

    const handleChange = (event) => {
      setSimilarColorThumb(event.target.value);
      localStorage.setItem('swatch-size', JSON.stringify(event.target.value))
    };
  
    return (
      <div className="radio-button-group">
        <div className="radio-button-container">
       
        <Radio
          checked={similarColorThumb === '20'}
          onChange={handleChange}
          color="primary"
          value="20"
          name="radio-buttons"
          inputProps={{ 'aria-label': '20' }}
        />
         <h6>SMALL</h6>
        </div>
        <div className="radio-button-container">
        
        <Radio
          checked={similarColorThumb === '25'}
          onChange={handleChange}
          color="primary"
          value="25"
          name="radio-buttons"
          inputProps={{ 'aria-label': '25' }}
        />
        <h6>MEDIUM</h6>
        </div>
        <div className="radio-button-container">
           
        <Radio
          checked={similarColorThumb === '30'}
          onChange={handleChange}
          color="primary"
          value="30"
          name="radio-buttons"
          inputProps={{ 'aria-label': '30' }}
        />
         <h6>LARGE</h6>
        </div>
      </div>
    );
}